<template>
	<div>
		<v-dialog v-model="dialog_confimation" persistent no-click-animation transition="slide-y-transition" max-width="290">
	      <v-card>
	      	<v-card-title class="title noshadow pb-0 pr-0 pt-0">
	      		Unsaved Changes
	      		<v-spacer></v-spacer>
	      		<v-btn flat icon @click="$parent.fn_closeDialog"><v-icon>close</v-icon></v-btn>
	      	</v-card-title>
	        <v-card-text>Do you want to save or discard changes?</v-card-text>
	        <v-divider></v-divider>
	        <!-- Data has been saved as draft. What would you like to do? -->
	        <v-card-actions style="padding:6px 0px;" center-align>
	        	<v-layout wrap>
	        		<v-flex xs4 sm4 md4 center-align greencolor :class="[hideKeepDraft ? 'xs6 sm6 md6' : 'xs4 sm4 md4']" v-if="!hideKeepDraft" style="border-right:1px #ddd solid">
	        			<v-btn font-heavy small capitalize dark-opacity-color flat @click="draftAction(false)">Save Draft</v-btn>
	        	  	</v-flex>
	        	  	<v-flex xs4 sm4 md4 center-align redcolor :class="[hideKeepDraft ? 'xs6 sm6 md6' : 'xs4 sm4 md4']" style="border-right:1px #ddd solid">
	        			<v-btn font-heavy small capitalize color="red darken-1" flat @click="draftAction(true)">Discard</v-btn>
	        	  	</v-flex>
	        	  	<v-flex xs4 sm4 md4 center-align :class="[hideKeepDraft ? 'xs6 sm6 md6' : 'xs4 sm4 md4']" @click="$parent.fn_closeDialog">
	        			<v-btn font-heavy small capitalize class="primary-color" flat @click="fn_save">Save</v-btn>    
	        	  	</v-flex>
	        	</v-layout>
		    </v-card-actions>
	      </v-card>
	    </v-dialog>
	</div>
</template>	 	

<script>

export default{
	props:['draftAction', 'save', 'hideKeepDraft'],
	data(){	
		return{
			dialog_confimation: false,
		}
	},
	methods: {
		openDialogWeb: function () {	
			this.dialog_confimation = true;
		},
		closeDialogWeb: function () {
			this.dialog_confimation = false;
		},
		fn_save: function(){
			this.$parent.fn_closeDialog();
			let self = this;
			setTimeout(function(){
				self.save();
			},300)	
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/dialogs/dialog_discard.vue